module.exports = __webpack_public_path__ + "static/media/unbounce_icon.fed1f1e2.svg";